import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import QuestionBlueIcon from '../../icons/QuestionBlueIcon.jsx';

const ImpactedCurrentCSVDownloadButton = ({ onDownloadCsv }) => {
  const [showModal, setShowModal] = useState(false);

  const handleClose = () => setShowModal(false);

  const handleShow = () => setShowModal(true);

  const renderModal = () => (
    <Modal bsSize="sm" show={showModal} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title>
          Use the following steps to bulk upload groups and people to the
          impacted groups and people Structure:
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ol>
          <li className="text-muted">
            Download impacted groups and people CSV below.
          </li>
          <li className="text-muted">
            Edit the CSV and add groups and people details you want to include
            in impacted groups and people Structure.
          </li>
          <li className="text-muted">
            Save the edited or new file as a CSV and upload it to ChangeSync.
          </li>
        </ol>
      </Modal.Body>
      <Modal.Footer>
        <Button block bsStyle="primary" onClick={onDownloadCsv} target="_blank">
          Download groups and people CSV
        </Button>
      </Modal.Footer>
    </Modal>
  );

  return (
    <React.Fragment>
      <button
        aria-label="View help"
        type="button"
        className="btn-clear flex flex-align-center p-0 text-muted text-left"
        onClick={handleShow}
      >
        Need a Current impacted groups and people Structure CSV? Click the
        question mark to download &nbsp;
        <QuestionBlueIcon />
      </button>
      {renderModal()}
    </React.Fragment>
  );
};

export default ImpactedCurrentCSVDownloadButton;
